import { Injectable } from '@angular/core';
import { BaseService } from 'cre-ng';
import { map } from 'rxjs/operators';

import {
  AccidentDetail,
  BonusDetail,
  CommitmentDetail,
  CriticalEventDetail,
  LateArrivalDetail,
  SafetyVideoDetail,
  WigAttendanceDetail,
} from './wig-stats.model';

@Injectable()
export class WigStatsService extends BaseService {
  getAccidentsDetails(driverId: string, qualifyPeriod: Date): Promise<BonusDetail[]> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    const timeOfTheCall = new Date().getTime();
    return this.httpClient
      .get<BonusDetail[]>(
        this.serviceUrl + `/qualifications/Accidents/${driverId}/${qualifyPeriod}?${timeOfTheCall}`,
        requestOptions
      )
      .toPromise();
  }

  getCommitmentDetails(
    driverId: string,
    leadSubject: string,
    startdate: Date,
    endDate: Date
  ): Promise<CommitmentDetail[]> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    const timeOfTheCall = new Date().getTime();
    return this.httpClient
      .get<CommitmentDetail[]>(
        this.serviceUrl +
          `/qualifications/commitments/${driverId}/${encodeURIComponent(
            leadSubject
          )}/${startdate}/${endDate}?${timeOfTheCall}`,
        requestOptions
      )
      .toPromise();
  }

  getCommitmentDetailsById(
    driverId: string,
    leadId: number,
    startdate: Date,
    endDate: Date
  ): Promise<CommitmentDetail[]> {
    const timeOfTheCall = new Date().getTime();
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    return this.httpClient
      .get<CommitmentDetail[]>(
        this.serviceUrl +
          `/qualifications/commitmentsbyid/${driverId}/${encodeURIComponent(
            leadId
          )}/${startdate}/${endDate}?${timeOfTheCall}`,
        requestOptions
      )
      .toPromise();
  }

  getCriticalEventsDetails(driverId: string, qualifyPeriod: Date): Promise<BonusDetail[]> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    const timeOfTheCall = new Date().getTime();
    return this.httpClient
      .get<BonusDetail[]>(
        this.serviceUrl +
          `/qualifications/CriticalEvents/${driverId}/${qualifyPeriod}?${timeOfTheCall}`,
        requestOptions
      )
      .toPromise();
  }

  getLateArrivalsDetails(driverId: string, qualifyPeriod: Date): Promise<BonusDetail[]> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    const timeOfTheCall = new Date().getTime();
    return this.httpClient
      .get<BonusDetail[]>(
        this.serviceUrl +
          `/qualifications/LateArrivals/${driverId}/${qualifyPeriod}?${timeOfTheCall}`,
        requestOptions
      )
      .toPromise();
  }

  getSafetyVideosDetails(driverId: string, qualifyPeriod: Date): Promise<BonusDetail[]> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    const timeOfTheCall = new Date().getTime();
    return this.httpClient
      .get<BonusDetail[]>(
        this.serviceUrl +
          `/qualifications/SafetyVideos/${driverId}/${qualifyPeriod}?${timeOfTheCall}`,
        requestOptions
      )
      .toPromise();
  }

  getWigAttendanceDetails(
    driverId: string,
    startdate: Date,
    endDate: Date
  ): Promise<WigAttendanceDetail[]> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    return this.httpClient
      .get<WigAttendanceDetail[]>(
        this.serviceUrl + `/qualifications/wigAttendance/${driverId}/${startdate}/${endDate}`,
        requestOptions
      )
      .toPromise();
  }

  getLogViolationDetails(driverId: string, qualifyPeriod: Date): Promise<BonusDetail[]> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    const timeOfTheCall = new Date().getTime();
    return this.httpClient
      .get<BonusDetail[]>(
        this.serviceUrl +
          `/qualifications/LogViolations/${driverId}/${qualifyPeriod}?${timeOfTheCall}`,
        requestOptions
      )
      .toPromise();
  }

  getCSAViolationDetails(driverId: string, qualifyPeriod: Date): Promise<BonusDetail[]> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    const timeOfTheCall = new Date().getTime();
    return this.httpClient
      .get<BonusDetail[]>(
        this.serviceUrl +
          `/qualifications/CSAViolations/${driverId}/${qualifyPeriod}?${timeOfTheCall}`,
        requestOptions
      )
      .toPromise();
  }

  getMissingDVR(driverId: string, qualifyPeriod: Date): Promise<BonusDetail[]> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    const timeOfTheCall = new Date().getTime();
    return this.httpClient
      .get<BonusDetail[]>(
        this.serviceUrl + `/qualifications/DVIR/${driverId}/${qualifyPeriod}?${timeOfTheCall}`,
        requestOptions
      )
      .toPromise();
  }

  getMissingPaperwork(driverId: string, qualifyPeriod: Date): Promise<BonusDetail[]> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    const timeOfTheCall = new Date().getTime();
    return this.httpClient
      .get<BonusDetail[]>(
        this.serviceUrl + `/qualifications/Paperwork/${driverId}/${qualifyPeriod}?${timeOfTheCall}`,
        requestOptions
      )
      .toPromise();
  }

  protected getEndPoint(): string {
    return '/safeandontime/api/v1';
  }
}
